import { Accordion } from "PFComponents/accordion/accordion";
import useStorage from "PFCore/helpers/use_storage";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./unseen_ownership.module.scss";

type UnseenProps = {
  activityType: "engagement" | "role";
};

export const UnseenOwnership = ({
  activityType,
  children
}: React.PropsWithChildren<UnseenProps>): JSX.Element => {
  const { t } = useTranslation("workflow");
  const [unseenState, setUnseenState] = useStorage<"open" | "closed">(`unseen_${activityType}_state`, "open");
  return (
    <Accordion defaultState={unseenState} onStateChange={setUnseenState} header={t("parts.unseenOwnership")}>
      <div className={css.unseenRoot}>
        <div className={css.scrollWrapper}>
          <div className={css.list}>{children}</div>
        </div>
      </div>
    </Accordion>
  );
};
